import { EXTERNAL_DELIVERY_COMPANIES } from '~constants/delivery';

export const withLogo = {
  sodexo: 'sodexo'
};

export const HARDCODED_PEYA_MAX_CASH_AMOUNT = 30000;

export const getExternalDeliveryCashMax = externalDeliveryCompany =>
  ({
    [EXTERNAL_DELIVERY_COMPANIES.PEDIDOS_YA]: HARDCODED_PEYA_MAX_CASH_AMOUNT
  }[externalDeliveryCompany]);
